export enum YellowButtonExportType {
  IPS = 'IPS',
  LABORATORY = 'LABORATORY',
}

export type LaboratoryExportRecordKind = 'MEDICAL_TEST' | 'CHOLESTEROL'

export type LaboratoryExportTarget = {
  kind: LaboratoryExportRecordKind
  recordId: string
}

export type YellowButtonExportLinkRequest = {
  expiration: string
  exportType?: YellowButtonExportType
  laboratoryRecord?: LaboratoryExportTarget
}

export type YellowButtonExportLink = {
  link: string
  expiration: string
  exportType: YellowButtonExportType
}

export type SelectedLabRecord = {
  kind: LaboratoryExportRecordKind
  id: string
  title: string
}
